import React from "react";
import './ProjectDetails.css';

const ProjectDetails = ({ imgUrl, heading, paragraph, technology, projectLink }) => {
  return (
    <div className="project-details-container">
      <div className="project-scroll-area">
        <div className="image-container">
          <img src={imgUrl} alt={heading} />
        </div>
        <div className="text-container">
          <h2 className="project-title">{heading}</h2>
          
          <div className="detail-section">
            <h4 className="section-label">Description</h4>
            <p className="section-content">{paragraph}</p>
          </div>

          <div className="detail-section">
            <h4 className="section-label">Technologies Used</h4>
            <p className="section-content">{technology}</p>
          </div>

          <div className="detail-section">
            <h4 className="section-label">Project Links</h4>
            <div className="links-group">
              {Array.isArray(projectLink) && projectLink.length > 0 ? (
                projectLink.map((link, id) => (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project-btn"
                    href={link}
                    key={id}
                  >
                    {projectLink.length > 1
                      ? id === 0 ? "Play Store" : "App Store"
                      : "View Website"}
                  </a>
                ))
              ) : (
                <span className="no-link">No links available</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectDetails;